/* Nature's Paw listicle V2 behaviour: review carousel arrows + sticky bottom CTA bar.
   V2 fix: the sticky bar's hide-over-buy-box IntersectionObserver observes the BUY BOX
   SECTION ELEMENT (.np-listicle-buy-box, full-height wrapper), never the zero-height
   #npl-buybox anchor div. */
(function () {
  'use strict';

  function initCarousels() {
    document.querySelectorAll('.npl-car').forEach(function (c) {
      var t = c.querySelector('.npl-track');
      if (!t) return;
      var p = c.querySelector('.npl-prev');
      var n = c.querySelector('.npl-next');
      if (p) p.addEventListener('click', function () { t.scrollBy({ left: -t.clientWidth * 0.9, behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { t.scrollBy({ left: t.clientWidth * 0.9, behavior: 'smooth' }); });
    });
  }

  function initSticky() {
    var bar = document.getElementById('npl-sticky');
    if (!bar) return;
    // Observe the buy box SECTION wrapper only. The #npl-buybox anchor div is
    // zero-height and must never be the observed element (V1 bug).
    var buyBox = document.querySelector('.np-listicle-buy-box');
    var overBuy = false;
    // 2026-09-09: no CTA before Reason 1. The bar appears once the Reason 3 CTA has scrolled past.
    var trig = document.getElementById('npl-cta-hero') || document.getElementById('npl-cta-r3');
    function past() { return trig ? trig.getBoundingClientRect().bottom < 0 : window.scrollY > 600; }
    var scrolled = past();

    function paint() {
      bar.classList.toggle('is-on', scrolled && !overBuy);
    }

    window.addEventListener('scroll', function () {
      var s = past();
      if (s !== scrolled) { scrolled = s; paint(); }
    }, { passive: true });

    if (buyBox && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        overBuy = entries[entries.length - 1].isIntersecting;
        paint();
      }, { threshold: 0 }).observe(buyBox);
    }
    paint();
  }

  /* V5: JS-driven smooth scroll for every .npl-btn anchor (hero, mid-page, criteria,
     CTA band, sticky bar). CSS scroll-behavior is applied inconsistently by
     WKWebView/browsers over long distances, so we animate scrollY ourselves with
     requestAnimationFrame (~800ms, ease-in-out) and land with ~12px headroom.
     If anything is missing (no target, no rAF), we return before preventDefault
     so the native anchor jump still works. */
  function initSmoothScroll() {
    if (!document.addEventListener || !Element.prototype.closest) return;

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function animateScrollTo(targetY) {
      var startY = window.pageYOffset || window.scrollY || 0;
      var delta = targetY - startY;
      var duration = 800;
      var startTime = null;
      // The stylesheet sets html{scroll-behavior:smooth}; per-frame scrollTo calls
      // would each trigger their own browser animation and fight the rAF loop.
      // Suspend it for the duration, restore after.
      var root = document.documentElement;
      var prevBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      function step(now) {
        if (startTime === null) startTime = now;
        var p = Math.min((now - startTime) / duration, 1);
        window.scrollTo(0, Math.round(startY + delta * easeInOut(p)));
        if (p < 1) {
          window.requestAnimationFrame(step);
        } else {
          root.style.scrollBehavior = prevBehavior;
        }
      }
      window.requestAnimationFrame(step);
    }

    document.addEventListener('click', function (e) {
      var link = e.target && e.target.closest ? e.target.closest('a.npl-btn') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;
      var target = document.getElementById(href.slice(1));
      if (!target || typeof window.requestAnimationFrame !== 'function') return; // native fallback
      e.preventDefault();
      var top = target.getBoundingClientRect().top + (window.pageYOffset || window.scrollY || 0) - 12;
      animateScrollTo(Math.max(0, top));
      if (window.history && history.replaceState) history.replaceState(null, '', href);
    });
  }

  function initHeroCarousel() {
    var c = document.querySelector('[data-hc]'); if (!c) return;
    var track = c.querySelector('[data-hc-track]'), slides = track.children, dots = c.querySelector('[data-hc-dots]'), i = 0;
    for (var k = 0; k < slides.length; k++) { dots.appendChild(document.createElement('b')); }
    function go(n) { i = (n + slides.length) % slides.length; track.style.transform = 'translateX(-' + (i * 100) + '%)'; for (var k = 0; k < dots.children.length; k++) dots.children[k].classList.toggle('is-on', k === i); }
    c.querySelector('[data-hc-prev]').addEventListener('click', function () { go(i - 1); });
    c.querySelector('[data-hc-next]').addEventListener('click', function () { go(i + 1); });
    var x0 = null, y0 = null;
    c.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    c.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1)); }, { passive: true });
    go(0);
  }
  /* Evergreen offer clock: each visitor gets a rolling deadline just under 3 hours away; it resets when it reaches zero. */
  function initCountdown() {
    var el = document.querySelector('[data-clock]'); if (!el) return;
    var H = el.querySelector('[data-clock-h]'), M = el.querySelector('[data-clock-m]'), S = el.querySelector('[data-clock-s]');
    var KEY = 'npl_offer_deadline', SPAN = (2 * 60 + 59) * 60 * 1000, end = 0;
    try { end = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
    function reset() { end = Date.now() + SPAN; try { localStorage.setItem(KEY, String(end)); } catch (e) {} }
    if (!end || end - Date.now() > SPAN || end < Date.now()) reset();
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() { var left = end - Date.now(); if (left <= 0) { reset(); left = end - Date.now(); } var t = Math.floor(left / 1000);
      H.textContent = pad(Math.floor(t / 3600)); M.textContent = pad(Math.floor((t % 3600) / 60)); S.textContent = pad(t % 60); }
    tick(); setInterval(tick, 1000);
  }
  function boot() { initCarousels(); initSticky(); initSmoothScroll(); initHeroCarousel(); initCountdown(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
